import { TRACKERS } from 'lib/analytics/trackers';

/** Meta Pixel ID. The live id lives in the tracker table. */
export const META_PIXEL_IDS = [TRACKERS.meta.id] as const;

export type MetaPixelId = (typeof META_PIXEL_IDS)[number];
